<template>
  <v-app>
    <default-view />
  </v-app>
</template>

<script>
  export default {
    name: 'UnauthenticatedLayout',
    components: {
      DefaultView: () => import(
        /* webpackChunkName: "unauthenticated-view" */
        './View'
      ),
    },
  }
</script>
